import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { LearningDomainInterface } from '../+models';

export const LEARNING_DOMAIN_SERVICE_TOKEN = new InjectionToken('LearningDomainService');

export interface LearningDomainServiceInterface {
  getAll(): Observable<LearningDomainInterface[]>;
  getLearningDomainsWithTopics(goalGroupId: number): Observable<LearningDomainInterface[]>;
  getLearningDomains$(
    searchTerm?: string,
    filters?: { [key: string]: string | number[] | number },
    pagination?: { from?: any; amount?: any },
    columns?: string[],
    sorting?: { [key: string]: 'asc' | 'desc' }
  ): Observable<{ results: LearningDomainInterface[]; count: number }>;
  createLearningDomain(learningDomain: LearningDomainInterface): Observable<LearningDomainInterface>;
  updateLearningDomain(learningDomain: LearningDomainInterface): Observable<LearningDomainInterface>;
  deleteLearningDomain(learningDomain: LearningDomainInterface): Observable<boolean>;
}
